var _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 348,
    viewBox: "0 0 469 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3942 347.25L0.946243 299.709L28.3942 252.167L83.2903 252.167L110.738 299.709L83.2903 347.25L28.3942 347.25Z",
    fill: "#E3EEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386.179 330.969L358.731 283.427L386.179 235.886L441.075 235.886L468.523 283.427L441.075 330.969L386.179 330.969Z",
    fill: "#F4EFF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9883 50.875L33.4766 27.472L46.9883 4.0691L74.0117 4.0691L87.5234 27.4721L74.0117 50.875L46.9883 50.875Z",
    fill: "#9DBDD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445.13 160.704L420.487 160.704L408.166 139.363L420.487 118.022L445.13 118.022L457.451 139.363L445.13 160.704Z",
    stroke: "#E3EEF5",
    strokeWidth: 4.1242,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.345 45.641L264.702 45.641L252.381 24.3002L264.702 2.95933L289.345 2.95932L301.666 24.3002L289.345 45.641Z",
    stroke: "#E4D6F5",
    strokeWidth: 4.1242,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.102,
    y: 31.0707,
    width: 367.675,
    height: 273.123,
    rx: 5.35276,
    stroke: "#9560D4",
    strokeWidth: 4.1242
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1641 36.4235C61.1641 34.6061 62.6373 33.1328 64.4547 33.1328H421.424C423.241 33.1328 424.714 34.6061 424.714 36.4235V62.2557H61.1641V36.4235Z",
    fill: "#C1A2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1641,
    y: 62.25,
    width: 363.55,
    height: 210.753,
    fill: "#F5F0FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 376.74,
    cy: 235.884,
    r: 22.1501,
    fill: "#C1A2E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3555,
    y: 73.5781,
    width: 33.3798,
    height: 33.3798,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.3555,
    y: 73.5781,
    width: 33.3798,
    height: 33.3798,
    fill: "#C1A2E7",
    style: {
      mixBlendMode: "color"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154.387,
    y: 81.6016,
    width: 177.106,
    height: 17.3257,
    fill: "#E4D6F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.285,
    y: 122.023,
    width: 223.307,
    height: 17.3257,
    fill: "#79A2BC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 161.414,
    y: 163.211,
    width: 163.053,
    height: 10.0103,
    fill: "#79A2BC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.898,
    y: 184.016,
    width: 188.079,
    height: 10.0103,
    fill: "#E4D6F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148.898,
    y: 199.805,
    width: 188.079,
    height: 10.0103,
    fill: "#E4D6F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5234 245.62C92.4684 244.149 97.5251 241.841 102.539 241.352C104.645 241.146 106.595 243.36 108.688 243.779C112.552 244.552 124.73 245.305 125.277 234.74C125.821 224.227 117.491 231.368 116.887 238.924C115.516 256.078 131.535 251.646 136.908 251.646C140.381 251.646 151.857 252.917 148.254 240.264C147.673 238.224 147.155 243.584 147.205 244.114C147.564 247.902 149.082 249.132 151.114 249.805C155.728 251.334 160.908 250.14 165.605 250.14C170.568 250.14 173.289 252.327 175.043 244.114",
    stroke: "#C1A2E7",
    strokeWidth: 4.1242,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1641 273H424.423V298.832C424.423 300.65 422.95 302.123 421.133 302.123H64.4547C62.6373 302.123 61.1641 300.65 61.1641 298.832V273Z",
    fill: "#C1A2E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M348.523 29.1188C348.523 27.3014 349.997 25.8281 351.814 25.8281H410.339C412.157 25.8281 413.63 27.3014 413.63 29.1188V78.7607C413.63 79.9582 412.98 81.0612 411.932 81.6406L382.155 98.1021C381.484 98.473 380.67 98.473 379.999 98.1021L350.222 81.6406C349.174 81.0612 348.523 79.9582 348.523 78.7607V29.1188Z",
    fill: "#9560D4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M379.001 99.9068L379.999 98.1021L379.001 99.9068C380.293 100.621 381.861 100.621 383.152 99.9068L412.929 83.4452C414.634 82.5028 415.692 80.7086 415.692 78.7607V29.1188C415.692 26.1625 413.296 23.766 410.339 23.766H351.814C348.858 23.766 346.461 26.1625 346.461 29.1188V78.7607C346.461 80.7086 347.52 82.5028 349.224 83.4452L379.001 99.9068Z",
    stroke: "#9560D4",
    strokeWidth: 4.1242
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M370.502 74.4688L360.086 63.5323C359.333 62.7434 358.91 61.6724 358.91 60.5554C358.91 59.4385 359.333 58.3674 360.086 57.5785C361.655 55.9317 364.188 55.9317 365.757 57.5785L373.358 65.5169L397.004 40.6882C398.573 39.0414 401.106 39.0414 402.675 40.6882C404.243 42.335 404.243 44.9952 402.675 46.642L376.173 74.4688C374.645 76.1156 372.071 76.1156 370.502 74.4688Z",
    fill: "#F5F3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.877137,
    height: 0.175427
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4255_381320",
    transform: "scale(0.00438568)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4255_381320",
    width: 200,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAoCAYAAAC7HLUcAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASoSURBVHgB7ZvbUSJBFIYbKau8VcFGsJ2BZCAZaAaSgb55e2D3QS3fMAPMADOADIYMxggWH7wVKnv+4XQ5ImgPMMN0c76qqR5ghlv33+f05S+ojKjX67rf71cLhcIOPdwbDAZli9t6dF1A5Z+np6duo9HoKcFZTk5Odqj+a3Ras7wlpKNN97RfX187V1dXocqYgkqJuCCokVfpKW17L12PP6X1+Ph4I6Lwj8PDw/La2toe1fE+HdUEt6KzDCAYaiPdi4uLQKXMzALBj93Y2NB0WqEvvb2yslLhc5sIYYgihYhi+Tg6OtIQyRRiUXQ92knw/v4eFIvFEKKhozdP4XwRCBp8qVSKGjdFgDJ9iTJ9gaikp36j4dO5pnP8MJ1QCHHw41qIFpQ+3YooBCMW6mR36WGVjmnbFgjpvSAadL4hi+kOj+n9o7aG89XV1ej8/v6+N64NFk5PTwcqG6IowelT+/LysqM8wXQqlCejw9BUASXuVDRfEpV4beRWrSxA5aIyY49Dfr8evxbyS3emUWSRfqQNxixU7NFRSRpd5kWaAkGFtnFAGK4PssekkmUqKzNG0VQxKYga9qbonLoPDw+Bi/WA/399fX0bQsGYlkqk8qn/7/MQSI97srbiiqAyOD8/v1OOgsrY3NxE49+GCJJOMuQdIxyO5h0PRGPGvXrewhknkE/hXA0bfU99CCHkskvHP5eFYDCCoLRod8pJBudBB4fBLv3+W6rTtnIcateow5LisTI/jbIcq1vzvOIx9pc6T22aN++cnZ1VqUFgQGimoWeCxwFhrAOJjw2ikj4rjN9j27mwgEv8Ob+44vF+ZgJFm8kTrvx4o0gMf/doqn1R6w95YWkEMhIlatNECJ4NCbjhB3mPoqYXRdrBEwSVaVIQTp+byygWrwXCA+toQUolTJtYDG01zNWdn2SIA+FQR1FB9KSHFT6sMGKhcctSTM17JxCIYmtrCzMdByqBKDgqtOgIlm1dJrb+sMMzRNry1iZde+PDmGUS3ggEYwoqECms93kpnoZGru3DZMO8MOsPvPZgE11COtpvb29/fUvBnBZIbKB9kGDzY5PKlk8LlWmC6FIsFrGyXVMWYjEpGHU4N8oDnBMIp1D71ND3bGafkDpBFL6t3i8CiAWdkRpGF/3D5aHyIKo4IxBOoeqWU7ISKVImtnUdW0G+jd4uD+xzLRBOoWynZUUUCyDJ1nVeX2m5NLDPnUB47t5MzeqfrseCFomo8fLy0pEdwYuFxyt1y5kwpL4tqrvrPKdguRCIEYXtqjbvCm49Pz9fiyjyyfHxca1g7/HAFpdmv9+/zZtYFiYQkz7RH4gcVlvcIimUgySMKiDaRJmXPWGZCUQ86YJ40mOIJ12YhHjSxZMuWCKe9MmIJ134hHjSxZOuR27VygLxpHvsSUf4gyDEk5494kmfHfGkj0E86W4gnvSMEE+6eNLFkz6CeNInI570D8STngDxpIsn3SvEkz4e8aTbI550Rjzp4kkfh3jSxZP+BfGkfyCedOFbxJPuGOJJXxziSc8x4knPF+JJzwHiSc8/4knPGPGku4t40lNCPOn+IZ70GRFP+nLguif9P9ipkdxJJwcFAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.b46cc2ea8a29a1aabc1a9fdcdc1f92f4.svg";
export { ForwardRef as ReactComponent };